module.exports = __webpack_public_path__ + "img/mapimg4.22846ce1.png";